import { DTO__image_size } from '@shared/dto/+image/image_asset_base/DTO__image_size';

export enum ENUM__ml_asset_family {
  UNKNOWN = '',
  NONE = 'NONE',
  MIXED = 'MIXED',

  /*
   * VISION
   */

  VISION_HED = 'VISION_HED',
  VISION_CV2 = 'VISION_CV2',
  VISION_DEPTH_ANYTHING = 'VISION_DEPTH_ANYTHING',

  VISION_SEGFORMER = 'VISION_SEGFORMER',
  VISION_SPANDREL__UPSCALER = 'VISION_SPANDREL__UPSCALER',
  /*
   * SD
   */
  SD_1 = 'SD_1',
  SD_2 = 'SD_2',
  SD_3 = 'SD_3',
  SD_XL = 'SD_XL',
  SD_XL_SSD_1B = 'SD_XL_SSD_1B',

  SD_XL_REFINER = 'SD_XL_REFINER',
  /*
   * CIVITAI TYPES
   */
  // // General
  // OTHER: 'OTHER',
  // // Custom Models
  // IMAGE_AURA_FLOW: 'IMAGE_AURA_FLOW',
  // IMAGE_COG_VIDEO_X: 'IMAGE_COG_VIDEO_X',
  // IMAGE_FLUX_1_S: 'IMAGE_FLUX_1_S',
  // IMAGE_FLUX_1_D: 'IMAGE_FLUX_1_D',
  // IMAGE_HIDREAM: 'IMAGE_HIDREAM',
  // IMAGE_HUNYUAN_1: 'IMAGE_HUNYUAN_1',
  // IMAGE_HUNYUAN_VIDEO: 'IMAGE_HUNYUAN_VIDEO',
  // IMAGE_ILLUSTRIOUS: 'IMAGE_ILLUSTRIOUS',
  // IMAGE_KOLORS: 'IMAGE_KOLORS',
  // IMAGE_LUMINA: 'IMAGE_LUMINA',
  // IMAGE_LTXV: 'IMAGE_LTXV',
  // IMAGE_MOCHI: 'IMAGE_MOCHI',
  // IMAGE_NOOBAI: 'IMAGE_NOOBAI',
  // IMAGE_ONNX: 'IMAGE_ONNX',
  // IMAGE_PIXART_A: 'IMAGE_PIXART_A',
  // IMAGE_PIXART_E: 'IMAGE_PIXART_E',
  // IMAGE_PONY: 'IMAGE_PONY',
  // IMAGE_PLAYGROUND_V2: 'IMAGE_PLAYGROUND_V2',
  // IMAGE_ODOR: 'IMAGE_ODOR',
  // IMAGE_OPENAI: 'IMAGE_OPENAI',
  // IMAGE_WAN_VIDEO: 'IMAGE_WAN_VIDEO',
  // /*
  //  * Stable Diffusion 1.0+
  //  */
  // IMAGE_SD_1_4: 'IMAGE_SD_1_4',
  // IMAGE_SD_1_5: 'IMAGE_SD_1_5',
  // IMAGE_SD_1_5_LCM: 'IMAGE_SD_1_5_LCM',
  // IMAGE_SD_1_5_HYPER: 'IMAGE_SD_1_5_HYPER',
  // /*
  //  * Stable Diffusion 2.0+
  //  */
  // IMAGE_SD_2_0: 'IMAGE_SD_2_0',
  // IMAGE_SD_2_0_768: 'IMAGE_SD_2_0_768',
  // IMAGE_SD_2_1: 'IMAGE_SD_2_1',
  // IMAGE_SD_2_1_768: 'IMAGE_SD_2_1_768',
  // IMAGE_SD_2_1_UNCLIP: 'IMAGE_SD_2_1_UNCLIP',
  // /*
  //  * Stable Diffusion 3.0+
  //  */
  // IMAGE_SD_3_0: 'IMAGE_SD_3_0',
  // IMAGE_SD_3_5: 'IMAGE_SD_3_5',
  // IMAGE_SD_3_5_LARGE: 'IMAGE_SD_3_5_LARGE',
  // IMAGE_SD_3_5_LARGE_TURBO: 'IMAGE_SD_3_5_LARGE_TURBO',
  // IMAGE_SD_3_5_MEDIUM: 'IMAGE_SD_3_5_MEDIUM',
  // /*
  //  * Stable Diffusion XL
  //  */
  // IMAGE_SDXL_0_9: 'IMAGE_SDXL_0_9',
  // IMAGE_SDXL_1_0: 'IMAGE_SDXL_1_0',
  // IMAGE_SDXL_1_0_LCM: 'IMAGE_SDXL_1_0_LCM',
  // IMAGE_SDXL_DISTILLED: 'IMAGE_SDXL_DISTILLED',
  // IMAGE_SDXL_HYPER: 'IMAGE_SDXL_HYPER',
  // IMAGE_SDXL_LIGHTNING: 'IMAGE_SDXL_LIGHTNING',
  // IMAGE_SDXL_TURBO: 'IMAGE_SDXL_TURBO',
  // // Other
  // IMAGE_SVD: 'IMAGE_SVD',
  // IMAGE_SVD_XT: 'IMAGE_SVD_XT',
  // IMAGE_STABLE_CASCADE: 'IMAGE_STABLE_CASCADE',
  // IMAGE_UNKNOWN: 'IMAGE_UNKNOWN',
}

const ENUM = ENUM__ml_asset_family;

// "",
export namespace ENUM_UTILS__ml_asset_family {
  export function get_families_for_filter() {
    let restricted_families = [ENUM__ml_asset_family.MIXED, ENUM__ml_asset_family.UNKNOWN];

    let out = Object.values(ENUM__ml_asset_family).filter(item => !restricted_families.includes(item));

    return out;
  }

  export function get_image_size_scaled(family: ENUM__ml_asset_family, aspect_ratio: number) {
    let out_map = new Map<ENUM__ml_asset_family, number>([
      [ENUM__ml_asset_family.NONE, 512],
      //
      //
      [ENUM__ml_asset_family.SD_1, 512],
      [ENUM__ml_asset_family.SD_2, 768],
      [ENUM__ml_asset_family.SD_3, 768],
      [ENUM__ml_asset_family.SD_XL, 1024],
    ]);

    if (!out_map.has(family)) {
      debugger;
      return DTO__image_size.CREATE_STUB();
    }

    let side = out_map.get_or_assert(family);

    let [width, height] = [Math.round(side * Math.sqrt(aspect_ratio)), Math.round(side / Math.sqrt(aspect_ratio))];
    [width, height] = [width.snap_to_8(), height.snap_to_8()];

    let out = new DTO__image_size(width, height);

    return out;
  }

  export function get_enum_generative(): Record<ENUM__ml_asset_family, string> {
    let families_list = [ENUM.SD_1, ENUM.SD_2, ENUM.SD_3, ENUM.SD_XL];

    let out: Record<ENUM__ml_asset_family, string> = {} as any;

    for (let [key, value] of Object.entries(ENUM__ml_asset_family)) {
      if (!families_list.includes(value)) continue;

      out[value] = key;
    }

    return out;
  }
}
